const collegeTeamHighlight = state => state.collegeTeamHighlight;

const collegeTeamHighlights = state => state.collegeTeamHighlights;

const collegeTeamHighlightLoading = state => state.collegeTeamHighlightLoading;

const collegeTeamHighlightsLoading = state =>
  state.collegeTeamHighlightsLoading;

const collegeTeamHighlightsLimited = state => state.collegeTeamHighlightsLimited

export default {
  collegeTeamHighlight,
  collegeTeamHighlights,
  collegeTeamHighlightLoading,
  collegeTeamHighlightsLoading,
  collegeTeamHighlightsLimited,
};
